export default {
  productFilterNone: { id: 'product_filter_none', defaultMessage: 'All' },
  productFilterMore: { id: 'product_filter_more', defaultMessage: 'More' },
  productFilterLess: { id: 'product_filter_less', defaultMessage: 'Less' },
}
